{
  "action": "Action",
  "allSides": "تمام اطراف",
  "allStatus": "تمام حیثیت",
  "amount": "رقم",
  "assetsWallet": "اثاثے / والیٹ",
  "available": "دستیاب",
  "availableBalance": "دستیاب بیلنس",
  "baseCurrency": "بیس کرنسی",
  "buy": "خریدیں",
  "buyExalt": "EXALT خریدیں",
  "buyLong": "خریدیں / لانگ",
  "buySellTabs": "خریدیں یا فروخت کریں",
  "buyToken": "کوائن خریدیں",
  "cancelOrder": "آرڈر منسوخ کریں",
  "cancelOrderFailed": "آرڈر کینسل نہیں ہو سکا",
  "cancelled": "کینسلڈ",
  "cancelledOrders": "منسوخ شدہ آرڈرز",
  "change24h": "24 گھنٹے تبدیلی",
  "close": "بند کریں",
  "completed": "مکمل",
  "confirmCancelOrder": "کیا آپ واقعی یہ آرڈر کینسل کرنا چاہتے ہیں؟",
  "connectWalletFirst": "پہلے والٹ کنیکٹ کریں",
  "cost": "لاگت",
  "deposits": "ڈپازٹس",
  "done": "مکمل",
  "enterAmount": "رقم درج کریں",
  "enterPrice": "قیمت درج کریں",
  "enterValidAmount": "براہ کرم درست رقم درج کریں۔",
  "enterValidPrice": "براہ کرم درست قیمت درج کریں۔",
  "exportCsv": "CSV ایکسپورٹ کریں",
  "failed": "ناکام",
  "filled": "فلڈ",
  "filledOrders": "مکمل شدہ آرڈرز",
  "filtered": "فلٹر شدہ",
  "hash": "ہیش",
  "high24h": "24 گھنٹے کی بلند ترین",
  "installWallet": "براہ کرم MetaMask یا Trust Wallet انسٹال کریں۔",
  "instruments": "انسٹرومنٹس",
  "insufficientBalance": "ناکافی بیلنس۔",
  "lastPrice": "آخری قیمت",
  "limit": "لمٹ",
  "limitOrder": "لمٹ آرڈر",
  "limitPrice": "لمٹ قیمت",
  "loadingOrders": "آرڈرز لوڈ ہو رہے ہیں...",
  "loadingTrades": "ٹریڈز لوڈ ہو رہے ہیں...",
  "loadingTransactions": "لین دین لوڈ ہو رہا ہے...",
  "low24h": "24 گھنٹے کی کم ترین",
  "manageFutures": "فیوچرز کا نظم کریں",
  "market": "مارکیٹ",
  "marketOrder": "مارکیٹ آرڈر",
  "marketOrderNotice": "مارکیٹ آرڈرز فوری طور پر دستیاب لیکویڈیٹی کے خلاف عمل میں لائے جاتے ہیں۔ عملدرآمد کی قیمت مختلف ہو سکتی ہے، اور غیر مکمل حصہ کھلا نہیں رہے گا - یہ فوری طور پر منسوخ ہو جاتا ہے۔",
  "marketPrice": "مارکیٹ قیمت",
  "mobileTradingChart": "موبائل ٹریڈنگ چارٹ",
  "moreOptions": "مزید آپشنز",
  "noFilledOrders": "کوئی مکمل شدہ آرڈر نہیں۔",
  "noOpenOrders": "کوئی کھلا آرڈر نہیں۔",
  "noOrdersFound": "کوئی آرڈر نہیں ملا۔",
  "noTradeHistory": "کوئی ٹریڈ تاریخ نہیں ملی۔",
  "noTransactionsFound": "کوئی لین دین نہیں ملا۔",
  "officialExaltContract": "Official EXALT Contract",
  "open": "اوپن",
  "openOrders": "اوپن آرڈرز",
  "orderBook": "آرڈر بک",
  "orderCancelledSuccessfully": "آرڈر کامیابی سے کینسل ہو گیا",
  "orderFailed": "آرڈر ناکام ہوگیا۔",
  "orderHistory": "آرڈر تاریخ",
  "orderIdMissing": "آرڈر آئی ڈی موجود نہیں ہے۔",
  "orderPlacedSuccessfully": "آرڈر کامیابی سے جمع ہوگیا۔",
  "orderType": "آرڈر ٹائپ",
  "pair": "Pair",
  "pending": "پینڈنگ",
  "placeOrder": "آرڈر دیں",
  "placingOrder": "آرڈر دیا جا رہا ہے...",
  "positionHistory": "پوزیشن ہسٹری",
  "price": "قیمت",
  "processing": "پروسیسنگ ہو رہی ہے...",
  "quoteCurrency": "کوٹ کرنسی",
  "recentTrades": "حالیہ ٹریڈز",
  "searchMarket": "مارکیٹ تلاش کریں...",
  "searchPair": "پیئر تلاش کریں...",
  "searchPairSideStatus": "جوڑا، طرف یا حیثیت تلاش کریں...",
  "searchTransactions": "لین دین تلاش کریں...",
  "selectPair": "جوڑا منتخب کریں",
  "sell": "فروخت کریں",
  "sellExalt": "EXALT بیچیں",
  "sellShort": "بیچیں / شارٹ",
  "serverError": "سرور میں خرابی۔",
  "sessionExpired": "سیشن ختم ہو گیا۔ براہ کرم دوبارہ لاگ ان کریں۔",
  "side": "Side",
  "slPrice": "SL قیمت",
  "spotMarkets": "اسپاٹ مارکیٹس",
  "spotTrading": "اسپاٹ ٹریڈنگ",
  "spotTradingSubtitle": "ایگزالٹ ایکسچینج کی طاقت سے چلنے والا پیشہ ورانہ اسپاٹ ٹریڈنگ انجن",
  "status": "اسٹیٹس",
  "stopLoss": "اسٹاپ لاس",
  "swapToExalt": "EXALT میں Swap کریں",
  "takeProfit": "ٹیک پرافٹ",
  "token": "ٹوکن",
  "total": "کل",
  "tpPrice": "TP قیمت",
  "tpSl": "TP/SL",
  "tradFi": "ٹریڈ فائی / سی ایف ڈی",
  "tradFiNoProvider": "ابھی تک کوئی سی ایف ڈی/ٹریڈ فائی لیکویڈیٹی پرووائیڈر منسلک نہیں ہے۔",
  "tradFiNoProviderDescription": "یہ ماڈیول پرووائیڈر کے لیے تیار اسٹیجنگ آرکیٹیکچر ہے۔ فاریکس، میٹلز، انڈیکس، اسٹاکس، اور کرپٹو سی ایف ڈی انسٹرومنٹس یہاں ظاہر ہوں گے جب کوئی حقیقی بروکر/لیکویڈیٹی پرووائیڈر منسلک اور تصدیق شدہ ہو۔",
  "tradFiStatusUnavailable": "فی الحال ٹریڈ فائی پرووائیڈر کی صورتحال لوڈ نہیں ہو سکی۔",
  "tradeHistory": "ٹریڈ تاریخ",
  "trades": "ٹریڈز",
  "tradingViewChart": "ٹریڈنگ ویو چارٹ",
  "transactionHistory": "ٹرانزیکشن ہسٹری",
  "volume24h": "24 گھنٹے والیوم",
  "walletConnected": "والیٹ کامیابی سے منسلک ہوگیا۔",
  "walletConnectionFailed": "والٹ کنیکٹ نہیں ہو سکا",
  "withdrawal": "نکاسی",
  "withdrawals": "نکاسی"
}